export default {
  title: {
    value: 'upsell_highlight_modal_title',
    defaultMessage: `Envie de gâter {petsAmount, plural,
      =1 {<highlighted>{petName}</highlighted>}
      other {vos compagnons}
    } ?`,
  },
  description: {
    value: 'upsell_highlight_modal_description',
    defaultMessage:
      'Découvrez notre <strong>sélection d’extras</strong> pour <strong>régaler</strong> votre boule de poils !',
  },
  primaryButton: {
    value: 'upsell_highlight_modal_button_primary',
    defaultMessage: 'Voir le produit',
  },
  secondaryButton: {
    value: 'upsell_highlight_modal_button_secondary',
    defaultMessage: 'Découvrir nos produits',
  },
}
